<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content}` : `SITE_NAME`
    }}</template>
  </metainfo>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { useMeta } from "vue-meta";

export default {
  setup() {
    useMeta({
      title: "Better Insights - Your data visualization partner",
      htmlAttrs: { lang: "en", amp: true },
      description:
        "We help you become a data-driven business. Make better decisions with beautiful custom-made dashboards. Save time and grow your business.",
    });

    // let route = this.$route.name;
    // console.log(route)
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700&family=Georgia:wght@400;500;600;700&display=swap");

:root {
  --font-family-body: "Nunito", sans-serif;
}

body {
  font-family: var(--font-family-body);
  font-weight: 400;
}

.font-regular {
  font-weight: 400;
}

p {
  font-family: var(--font-family-body);
  font-weight: 400;
}

#app {
  overflow: hidden;
}
</style>
